@if (!loggedIn) {
    <button mat-button [disabled]="!login_activated" (click)="login()" class="login-button">
        Anmelden
    </button>
}

@if (loggedIn && activeProvider$) {
    @if (currentUser$ | async; as currentUser) {
        @if (activeProvider$ | async; as activeProvider) {
            <button mat-button [matMenuTriggerFor]="menu" style="height: auto;">
                <mat-card class="profil-card">
                    <!-- In case picture upload for users is implemented -->
                    <!-- <img mat-card-avatar class="profil-image" [src]="userService.getUserPicture()" /> -->
                    <img class="profil-image" [src]="'/assets/svg-icons/profile_check.svg'" />
                    <div class="profil-name-container">
                        <span class="provider-name user-name">{{ currentUser.firstName }} {{ currentUser.lastName }}</span>
                        @if (activeProvider.organisationId) {
                            <span class="provider-name active-org-name">{{ activeProvider.name }}</span>
                        }
                    </div>
                </mat-card>
            </button>
        }
    }

    <mat-menu #menu="matMenu" xPosition="before" color="primary">

        <!-- Personal Settings -->
        <span class="menu-headers">PERSÖNLICH</span>
        <button mat-menu-item (click)="openMySettings()">
            <mat-icon>settings</mat-icon>
            Mein Profil
        </button>
        <button mat-menu-item (click)="openMyProducts()" color="primary">
            <mat-icon>bookmark</mat-icon>
            Merkliste
        </button>
        <!-- Composer -->
        <button *ngIf="this.userService.currentUser.hasComposerAccess" mat-menu-item (click)="openComposer()" color="primary">
            <mat-icon>trip_origin</mat-icon>
            Composer
        </button>

        <hr class="sep-line" />

        @if (activeProvider?.organisationId) {
            <!-- Organization Switcher and Settings -->
            <span class="menu-headers">ORGANISATION</span>
            <!-- <div> -->
                <div class="orgas scrollable-container-small">
                    @for (provider of providers; track $index) {
                            <button matButton matRipple (click)="headerService.setActiveProvider(provider)" class="orga">
                                <img mat-card-avatar class="example-header-image" [src]="provider.img" />
                                <span class="provider-name">
                                    {{ provider.name }}
                                </span>
                            </button>
                    }
                </div>
            <!-- </div> -->
            <hr class="sep-line" />
        }

        <!-- Logout -->
        <button mat-menu-item (click)="logout()" color="primary">
            <mat-icon>logout</mat-icon>
            Abmelden
        </button>
    </mat-menu>
}
